import { useTranslation } from "react-i18next";

type MediaLoadErrorProps = {
  onRetry: () => void;
  isRetrying?: boolean;
};

const MediaLoadError = ({ onRetry, isRetrying = false }: MediaLoadErrorProps) => {
  const { t } = useTranslation();

  return (
    <div className="w-full 2xl:max-w-[32.083vw] max-w-[616px] mx-auto flex flex-col items-center justify-center 2xl:gap-[0.6vw] gap-2 2xl:mt-[0.8vw] md:mt-3 mt-1 py-4 px-3 rounded-xl border-[1.5px] border-black-300 bg-[#F2BF7D]/30">
      <p className="text-black-300 font-garamond font-bold 2xl:text-[1.042vw]/tight xl:text-lg/tight text-base/tight text-center">
        {t("gameAnswer.mediaLoadFailed")}
      </p>
      <button
        type="button"
        onClick={onRetry}
        disabled={isRetrying}
        className="skew-x-[-10deg] 2xl:border-[0.104vw] border-[1.5px] border-black-300 bg-primary-orange flex items-center 2xl:py-[0.5vw] xl:py-1.5 py-1 2xl:px-[1.042vw] lg:px-4 md:px-3 px-2.5 2xl:rounded-[0.26vw] rounded-[5px] 2xl:text-[0.9375vw]/[1.04vw] xl:text-base/tight text-sm/tight font-bold text-white cursor-pointer justify-center text-nowrap 2xl:shadow-[0px_0.156vw_0px_#110706] shadow-[0px_2px_0px_#110706] disabled:opacity-60 disabled:cursor-not-allowed"
      >
        <span className="skew-x-10 2xl:mt-[0.208vw] mt-1">
          {isRetrying ? t("gameBoard.retrying") : t("gameAnswer.retryMedia")}
        </span>
      </button>
    </div>
  );
};

export default MediaLoadError;
